import React, { useState, useEffect, useContext} from 'react';
import { sendGetRequest } from '../../../../Helper/helper';
import Context from "../../../../context/context";

export default function BurnCalculator() {
  const {ufoPrice} = useContext(Context);
  const [multiplier, setMultiplier] = useState('10x');
  const [dailyBurn, setDailyBurn] = useState(0);

  useEffect(() => {
    getBurnStats();
  }, []);

  const getBurnStats = async () => {
    try {
      const response = await sendGetRequest('ufo/historical/burn', 'GET');
      if (response && response.status === 200 && response.data) {
        setDailyBurn(parseFloat(response.data['24H']) * ufoPrice);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  return (
    <div className="container">
      <div className="row m-0 justify-content-center">
        <div className="col-md-12 col-xl-12 p-0 CalculatorTop statsALL">
        
          <div className="burnSec bSRIN overHide subcontent">
            <div className="snPortal">
              <div className="SRTOP d-flex flex-wrap justify-content-between align-items-center">
                <h2 className="mb-0">Burn Calculator</h2>
                <div className="iconSR">
                  <img src="./images/MathOperations.svg" className="img-fluid" alt="icon" />
                </div>
              </div>
            </div>
            <div>
              <div className="row m-0 ">
                <div className="col-md-12 col-xl-12 p-0">
                  <div className="row">
                    <div className="col-md-6 col-xl-6 borderRight">
                      <div className="boxes2">
                        <label className="fInter mb-1" htmlFor="burnTodayInput">Burns Today ($)</label>
                        <h3 className="dollorValue value">
                          <span className="dollor">$</span>
                          <span>{parseFloat(dailyBurn).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </h3>
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-6">
                      <div className="boxes2">
                        <label className="fInter mb-1" htmlFor="multiplierInput">Multiplier</label>
                        <input
                          id="multiplierInput"
                          value={multiplier}
                          onChange={(e) => {
                            let value = e.target.value;
                            const validPattern = /^-?\d*\.?\d*x?$/;
                            if (validPattern.test(value) || value === "" || value === ".") {
                              setMultiplier(value);
                            }
                          }}
                          className="input w-100"
                          placeholder="e.g., 2x"
                          style={{
                            background: "rgb(0 0 0 / 33%)",
                            padding: "10px",
                            width: "100%",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="burnSec bSRIN overHide subcontent">
            <div className="snPortal">
              <div className="SRTOP d-flex flex-wrap justify-content-between align-items-center">
                <h2 className="mb-0">Burn Result</h2>
              </div>
            </div>
              <div className="row m-0">
                 <div className={`col-md-6 col-xl-6 p-0 borderRight borderBottom`}>
                    <div className="boxes2">
                      <div className="result-single">
                        <div className="perVal fInter d-flex align-items-center flex-wrap">
                          <span>24H Burn</span>
                          <span className="dot"></span>
                          <span>Burn</span>
                        </div>
                        <h3 className="dollorValue value">
                          <span className="dollor">$</span>
                          <span>{parseFloat(dailyBurn * (parseFloat(multiplier?.toString().replace('x', '')) || 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div className={`col-md-6 col-xl-6 p-0 borderRight borderBottom`}>
                    <div className="boxes2">
                      <div className="result-single">
                        <div className="perVal fInter d-flex align-items-center flex-wrap">
                           <span>1W Burn</span>
                          <span className="dot"></span>
                          <span>Burn</span>
                        </div>
                        <h3 className="dollorValue value">
                          <span className="dollor">$</span>
                          <span>{parseFloat(dailyBurn * (parseFloat(multiplier?.toString().replace('x', '')) || 0) * 7).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </h3>
                      </div>
                    </div>
                  </div>
                  
                  <div className={`col-md-6 col-xl-6 p-0 borderRight borderBottom`}>
                    <div className="boxes2">
                      <div className="result-single">
                        <div className="perVal fInter d-flex align-items-center flex-wrap">
                          <span>1M Burn</span>
                          <span className="dot"></span>
                          <span>Burn</span>
                        </div>
                        <h3 className="dollorValue value">
                          <span className="dollor">$</span>
                          <span>{parseFloat(dailyBurn * (parseFloat(multiplier?.toString().replace('x', '')) || 0) * 30).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div className={`col-md-6 col-xl-6 p-0 borderRight borderBottom`}>
                    <div className="boxes2">
                      <div className="result-single">
                        <div className="perVal fInter d-flex align-items-center flex-wrap">
                          <span>1Y Burn</span>
                          <span className="dot"></span>
                          <span>Burn</span>
                        </div>
                        <h3 className="dollorValue value">
                          <span className="dollor">$</span>
                          <span>{parseFloat(dailyBurn * (parseFloat(multiplier?.toString().replace('x', '')) || 0) * 365).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </h3>
                      </div>
                    </div>
                  </div>
               </div>
            </div>
        </div>
      </div>
    </div>
  );
}
